import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';

import { TituloReceberResumoComponent } from './titulo-receber-resumo.component';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        TituloReceberResumoComponent
    ],
    exports: [
        TituloReceberResumoComponent
    ]
})
export class TituloReceberResumoModule { }
